import React, { useEffect } from "react";
import { useFormik } from "formik";
import { tvStakeholderSchema } from "../../schema/schema";
import CommonHeadingNBtns from "../common-components/CommonHeadingNBtns";
import { fetchInHouseUsersData } from "../../redux/reducers/dropdownApiSlice";
import { useDispatch, useSelector } from "react-redux";
import { commonPostPutApi } from "../../redux/reducers/commonApiSlice";
import { tvStakeholderAdditionalAdd } from "../../data/ApiEndpoints";
import { toast } from "react-toastify";
import SelectDropdownLabel from "../components-react/SelectDropdownLabel";
import { stakeholderOptions } from "./tv-utils";

const TvUserTaggingUpdate = ({
  callFunction,
  initialValues,
  isEdit,
  token,
  closeModal,
  isRoleWise,
}) => {
  const dispatch = useDispatch();

  console.log("initialValues", initialValues);

  const { inhouseUsers } = useSelector((state) => state.dropdown);

  useEffect(() => {
    dispatch(
      fetchInHouseUsersData({
        token,
        qps: "account_type=admin,security",
        pageNo: 1,
        limit: 100,
      })
    );
  }, [dispatch, token]);

  const formik = useFormik({
    initialValues: {
      user_id: initialValues ? initialValues.uid : "",
      tv_stakeholder_type: initialValues
        ? initialValues.tv_stakeholder_type
        : "",
    },
    validationSchema: tvStakeholderSchema,

    onSubmit: async (values) => {
      const method = "POST";
      const endpoint = isEdit
        ? tvStakeholderAdditionalAdd
        : tvStakeholderAdditionalAdd;

      const payload = {
        ...(initialValues?.uid && { uid: initialValues.uid }),
        user_id: values.user_id,
        tv_stakeholder_type: values.tv_stakeholder_type,
      };

      const result = await dispatch(
        commonPostPutApi({ method, endpoint, payload, token })
      );

      // console.log("result is==>", result);

      if (result?.payload?.status) {
        toast.success(result?.payload?.message || "Success!");
        closeModal();
        callFunction();
      } else {
        const errorMessage = result?.error?.message || result?.payload?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    },
  });

  // console.log("formik values", formik);

  return (
    <div className="createNewCTOModalContainer mod-width-70p">
      <CommonHeadingNBtns
        title={`${isEdit ? "Edit" : "Add"} Additional Stakeholder`}
        btnTxt={isEdit ? "Update" : "Save"}
        onClick={formik.handleSubmit}
        isLoading={formik.isSubmitting}
        onClose={closeModal}
      />

      <form className="formContainer" onSubmit={formik.handleSubmit}>
        <div className="formInputsGrid twoGridSystem">
          {!isRoleWise && (
            <div>
              <label htmlFor="user_id" className="labelTv">
                User
                <span className="text-danger">*</span>
              </label>
              <div className="commonWrapper dropdownCommonWrapper">
                <SelectDropdownLabel
                  name="Select User"
                  options={inhouseUsers || []}
                  value={inhouseUsers?.find(
                    (option) => option.value === formik.values.user_id
                  )}
                  setSelectedOption={(selectedOption) =>
                    formik.setFieldValue("user_id", selectedOption?.value)
                  }
                />
              </div>
              {formik.touched.user_id && formik.errors.user_id && (
                <div className="error-message">{formik.errors.user_id}</div>
              )}
            </div>
          )}

          <div>
            <label htmlFor="tv_stakeholder_type" className="labelTv">
              StakeHolder Type
              <span className="text-danger">*</span>
            </label>
            <div className="commonWrapper dropdownCommonWrapper">
              <SelectDropdownLabel
                name="StakeHolder Type"
                options={stakeholderOptions}
                value={stakeholderOptions.find(
                  (option) => option.value === formik.values.tv_stakeholder_type
                )}
                setSelectedOption={(selectedOption) =>
                  formik.setFieldValue(
                    "tv_stakeholder_type",
                    selectedOption?.value
                  )
                }
              />
            </div>

            {formik.touched.tv_stakeholder_type &&
              formik.errors.tv_stakeholder_type && (
                <div className="error-message">
                  {formik.errors.tv_stakeholder_type}
                </div>
              )}
          </div>
        </div>
      </form>
    </div>
  );
};

export default TvUserTaggingUpdate;
